import CrudCustom from '../../../libs/custom/CrudCustom';

let TransaksiLabaRugiService = new CrudCustom('/transaksi-laba-rugis');
export default TransaksiLabaRugiService;
